import React, { useMemo } from 'react';
import GPTFeedBackLikeDislike from './GPTFeedBackLikeDislike';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';

const BOB_ID = '682af568e53e9a99e15bad85';

const Component = (props) => {
    const senderId = useMemo(() => {
        return (props?.user || {})?.id;
    }, [props?.user]);

    if (!props?.rId) {
        return null;
    }
    if (senderId !== BOB_ID) {
        return null;
    }
    return (
        <div
            className="d-flex flex-col justify-content-center align-items-end dropper "
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div></div>
            <div
                className="d-flex flex-row"
                style={{
                    height: 'fit-content',
                    cursor: 'pointer',
                    transition: 'box-shadow 0.2s ease',
                    borderRadius: '14px',
                    padding: '4px',
                    margin: '0 4px',
                    zIndex: 10,
                    backgroundColor: '#F5F5F5',
                    boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
                }}
            >
                {props?.roomType ? <GPTFeedBackLikeDislike {...props} /> : null}
            </div>
        </div>
    );
};

const GPTFeedbackMessageHoverActionContainer = (props) => (
    <ComponentErrorBoundary>
        <Component {...props} />
    </ComponentErrorBoundary>
);
export default GPTFeedbackMessageHoverActionContainer;
